import { render, staticRenderFns } from "./ParticipanListBlock.vue?vue&type=template&id=56319da0&scoped=true&"
import script from "./ParticipanListBlock.vue?vue&type=script&lang=js&"
export * from "./ParticipanListBlock.vue?vue&type=script&lang=js&"
import style0 from "./ParticipanListBlock.vue?vue&type=style&index=0&id=56319da0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56319da0",
  null
  
)

export default component.exports